<template lang="html">
  <div
    class="product-details-skeleton w-full max-w-(--ui-container) px-4 pt-6 pb-28 sm:m-auto sm:px-6 lg:pb-10"
    aria-busy="true"
    aria-live="polite"
  >
    <span class="sr-only">Загрузка товара…</span>

    <div class="mb-4 flex flex-wrap items-center gap-2">
      <USkeleton class="h-4 w-16" />
      <USkeleton class="h-4 w-3" />
      <USkeleton class="h-4 w-24" />
      <USkeleton class="h-4 w-3" />
      <USkeleton class="h-4 w-32" />
    </div>

    <div
      class="mb-10 items-start gap-8 lg:mb-12 lg:grid lg:grid-cols-[minmax(0,1.15fr)_minmax(320px,0.85fr)] lg:gap-10"
    >
      <div class="flex flex-col gap-3">
        <USkeleton class="aspect-square w-full rounded-md" />
        <div class="hidden gap-2 sm:flex">
          <USkeleton
            v-for="i in 4"
            :key="i"
            class="size-16 shrink-0 rounded-md"
          />
        </div>
      </div>

      <aside class="flex flex-col gap-4">
        <div class="flex flex-wrap items-center gap-3">
          <USkeleton class="h-4 w-28" />
          <USkeleton class="h-4 w-20" />
        </div>

        <div class="flex items-start justify-between gap-4">
          <div class="flex min-w-0 flex-1 flex-col gap-2">
            <USkeleton class="h-7 w-full max-w-md" />
            <USkeleton class="h-7 w-2/3 max-w-xs" />
          </div>
          <USkeleton class="size-10 shrink-0 rounded-md" />
        </div>

        <USkeleton class="h-6 w-16 rounded" />
        <USkeleton class="h-8 w-36" />

        <div class="flex flex-wrap gap-2">
          <USkeleton
            v-for="i in 3"
            :key="i"
            class="h-10 w-16 rounded-md"
          />
        </div>

        <USkeleton class="h-12 w-full max-w-xs rounded-md" />
        <USkeleton class="hidden h-12 w-full rounded-md lg:block" />

        <div class="mt-2 flex flex-col gap-2">
          <USkeleton class="h-4 w-48" />
          <USkeleton class="h-4 w-40" />
        </div>
      </aside>
    </div>

    <div class="mb-8 flex flex-col gap-4">
      <div class="flex gap-4">
        <USkeleton class="h-8 w-24" />
        <USkeleton class="h-8 w-32" />
        <USkeleton class="h-8 w-28" />
      </div>
      <USkeleton class="h-4 w-full max-w-2xl" />
      <USkeleton class="h-4 w-full max-w-xl" />
      <USkeleton class="h-4 w-2/3 max-w-lg" />
    </div>
  </div>
</template>
